import { FaPhone, FaWhatsapp, FaEye, FaExternalLinkAlt } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'

const ToolCard = ({ tool }) => {
    const navigate = useNavigate()

    const handleCardClick = (e) => {
        if (e.target.closest('a'))
            return
        navigate(`/tools/${tool._id}`)
    }

    return (
        <div
            className="bg-white shadow-md rounded-xl overflow-hidden transition-all duration-300 hover:shadow-xl hover:-translate-y-1 h-88"
        >

            <div
                onClick={handleCardClick}
                className="group relative cursor-pointer"
            >
                <div
                    className="md:hidden absolute top-3 left-3 z-20 bg-white/90 text-haskurit-gray p-2 rounded-full shadow-md"
                >
                    <FaExternalLinkAlt size={14} />
                </div>

                <div className="h-44 bg-gray-100 overflow-hidden">

                    <img
                        src={tool.imageUrl}
                        alt={tool.name}
                        className="w-full h-full object-contain p-2 transition-transform duration-300 group-hover:scale-105"
                        loading="lazy"
                    />

                </div>

                <div className="p-4 min-h-[140px]">

                    <h3 className="text-xl font-bold text-haskurit-gray mb-1">
                        {tool.name}
                    </h3>

                    <p className="text-sm text-gray-600 line-clamp-3">
                        {tool.description}
                    </p>

                </div>

                <div
                    className="hidden md:flex absolute inset-0 bg-white/40 backdrop-blur-[3px] opacity-0 group-hover:opacity-100 transition-opacity duration-300 items-center justify-center z-10"
                >
                    <div
                        className="flex items-center gap-2 bg-white px-4 py-2 rounded-full shadow-lg text-haskurit-gray font-medium"
                    >
                        <FaEye />
                        <span>לצפייה בפרטים</span>
                    </div>
                </div>

            </div>

            <div
                className="border-t border-gray-100 bg-gray-50/50 px-4 py-3 flex justify-between items-center"
            >

                <span className="text-lg font-semibold text-haskurit-yellow">
                    ₪{tool.price} ליום
                </span>

                <div className="flex items-center gap-3 shrink-0">

                    <a
                        href="tel:+972527694198"
                        aria-label="התקשר עכשיו"
                        className="bg-[#ECECEC] text-haskurit-gray p-2.5 rounded-full transition-all duration-200 hover:bg-[#DCDCDC] hover:scale-110 hover:shadow-md hover:-translate-y-0.5"
                    >
                        <FaPhone />
                    </a>

                    <a
                        href="https://wa.me/972527694198?text=שלום, אני מעוניין/ת בהשכרת כלי עבודה"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="שלח WhatsApp"
                        className="bg-[#ECECEC] text-green-500 p-2.5 rounded-full transition-all duration-200 hover:bg-[#DCDCDC] hover:scale-110 hover:shadow-md hover:-translate-y-0.5"
                    >
                        <FaWhatsapp className="scale-110" />
                    </a>

                </div>
            </div>
        </div>
    )
}

export default ToolCard